import { OAuthConnectPage } from "../oauth-connect-page"

export function ConnectXeroPage() {
  return <OAuthConnectPage provider="xero" displayName="Xero" returnPath="/setup/connect" />
}
